/* Strawhat header: solid background after scrolling, and the menu fit. Wide screens: one line of links (the wordmark
   hides only when the links wouldn't fit). v2.1.1: on phones, or whenever the links still don't fit, the row turns
   into a ☰ button that drops down every link, so the menu never scrolls sideways. */
(() => {
  const PHONE = window.matchMedia('(max-width: 749px)');
  let header = null;
  let nav = null;
  let burger = null;

  const onScroll = () => header && header.classList.toggle('is-solid', window.scrollY > 40);

  const setOpen = (open, focus) => {
    if (!header || !burger) return;
    header.classList.toggle('is-open', open);
    burger.setAttribute('aria-expanded', String(open));
    burger.setAttribute('aria-label', open ? 'Close Menu' : 'Menu');
    if (open && focus) { const first = nav.querySelector('a'); if (first) first.focus(); }
  };

  const fit = () => {
    if (!header || !nav) return;
    const wasMenu = header.classList.contains('is-menu');
    header.classList.remove('is-menu', 'is-compact');
    let menu = PHONE.matches;
    if (!menu && nav.scrollWidth > nav.clientWidth + 1) {
      header.classList.add('is-compact');
      if (nav.scrollWidth > nav.clientWidth + 1) { header.classList.remove('is-compact'); menu = true; }
    }
    header.classList.toggle('is-menu', menu);
    if (wasMenu && !menu) setOpen(false);
  };

  const init = () => {
    header = document.querySelector('[data-sh-header]');
    nav = header ? header.querySelector('[data-sh-nav]') : null;
    burger = header ? header.querySelector('[data-sh-burger]') : null;
    if (burger && nav) {
      burger.addEventListener('click', () => setOpen(!header.classList.contains('is-open'), true));
      // A tap on a link closes the menu (most links jump to a spot on the home page).
      nav.addEventListener('click', (e) => { if (e.target.closest('a')) setOpen(false); });
    }
    onScroll();
    fit();
  };

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && header && header.classList.contains('is-open')) { setOpen(false); burger.focus(); }
  });
  // Capture phase, so a tap outside closes the menu even where a section stops the click from bubbling.
  document.addEventListener('click', (e) => {
    if (header && header.classList.contains('is-open') && !nav.contains(e.target) && !burger.contains(e.target)) setOpen(false);
  }, true);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', fit);
  (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(fit);
  init();

  /* Theme editor: the header section is re-rendered when edited. */
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('[data-sh-header]')) init();
  });
})();
